import { Box , Tooltip,FormControl, MenuItem, Select} from "@mui/material";
import { ReactComponent as SubtractIcon } from "../../assets/image/svg/subtractIcon.svg";
import { viewPrimaryOrderRowsData } from "../../types/types";
import { truncateToTwoDecimals } from "../../components/dms_common/DmsUtils";
import { TruncatedTextUptoLine } from "../../components/dms_common/DmsUtils";
import { ReactComponent as CircledRight } from "../../assets/image/svg/circledRight.svg";
import { viewManageOrderRowsData } from "../viewOrder/ViewOrderType";
import { UOM } from "../createSecondaryOrder/CreateSecondaryOrderType";
import "./ViewPrimaryOrder.css";
export const getViewPrimaryOrderConfig = (
  toggleTaxInfoCollapsedStatus: (
    paramRow: viewPrimaryOrderRowsData,
    collapsed: boolean
  ) => void, handlePromotionModalVisibility: (paramRow: viewPrimaryOrderRowsData) => void,
    showTaxPercentage: boolean = true,
    isARS?: boolean
) => {
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
  const { packUnitLabelPrimary,caseUnitLabelPrimary,otherUnitLabelPrimary,currency } = ConfigDictionary;

  return {
    columns: [
      {
        headerName: "SKU Code",
        mappedValue: "batchCode",
        width: 100,
        renderHeader: (value: any) => (
          <Box display={"flex"} flexDirection={"column"}>
            <span>{"SKU"}</span>
            <span>{"Code"}</span>
          </Box>
        ),
        renderCell: (value: any, row: any) => {
          return (
              <Tooltip title={value}>
              <Box className="sku_name_truncate_text">
                <span style={TruncatedTextUptoLine(2)}>{value}</span>
              </Box>
            </Tooltip>
          );
        },
      },
      {
        headerName: "SKU Name",
        mappedValue: "skuDescription",
        width: 180,
        renderHeader: (value: any) => (
          <Box display={"flex"} flexDirection={"column"}>
            <span>{"SKU"}</span>
            <span>{"Name"}</span>
          </Box>
        ),
        renderCell: (value: any) => {
          return (
            <Tooltip title={value}>
              <Box className="sku_name_truncate_text">
                <span style={TruncatedTextUptoLine(2)}>{value}</span>
              </Box>
            </Tooltip>
          );
        },
      },
      {
        headerName: "Promotion",
        mappedValue: "promotion",
        width: 130,
        renderCell: (value: any, row: any) => {
          if (+row?.discount === 0) return <></>;
          return (
            <div
              className="view-discounts-container"
              onClick={() => handlePromotionModalVisibility(row)}
            >
              <span>View Promos</span>
              <CircledRight style={{ width: "10px" }} />
            </div>
          );
        },
      },
      ...(caseUnitLabelPrimary
        ? [
            {
              headerName: "Cases",
              mappedValue: "caseQuantity",
              width: 60,
              textAlign: "center",
              renderHeader: () => (
                <Box display="flex" sx={{ flexDirection: "column", alignItems: "center" }}>
                  <Box display="flex" flexDirection="column" sx={{ textAlign: "left" }}>
                    <span>{"Qty"}</span>
                    <span>{`(${caseUnitLabelPrimary})`}</span>
                  </Box>
                </Box>
              ),
              renderCell: (value: any) => (
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <div className="view_order_pack_quantity_input style_adjust">{value}</div>
                </Box>
              ),
            },
          ]
        : []),
      ...((otherUnitLabelPrimary && !isARS)
        ? [
            {
              headerName: "Others",
              mappedValue: "otherUnitQuantity",
              width: 60,
              textAlign: "center",
              renderHeader: () => (
                <Box display="flex" sx={{ flexDirection: "column", alignItems: "center" }}>
                  <Box display="flex" flexDirection="column" sx={{ textAlign: "left" }}>
                    <span>{"Qty"}</span>
                    <span>{`(${otherUnitLabelPrimary?.slice(0, 3)})`}</span>
                  </Box>
                </Box>
              ),
              renderCell: (value: any) => (
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <div className="view_order_pack_quantity_input style_adjust">{value}</div>
                </Box>
              ),
            },
          ]
        : []),
      ...((packUnitLabelPrimary && !isARS)
        ? [
            {
              headerName: "Pieces",
              mappedValue: "pieceQuantity",
              width: 60,
              textAlign: "center",
              renderHeader: () => (
                <Box display="flex" sx={{ flexDirection: "column", alignItems: "center" }}>
                  <Box display="flex" flexDirection="column" sx={{ textAlign: "left" }}>
                    <span>{"Qty"}</span>
                    <span>{`(${packUnitLabelPrimary})`}</span>
                  </Box>
                </Box>
              ),
              renderCell: (value: any) => (
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <div className="view_order_pack_quantity_input style_adjust">{value}</div>
                </Box>
              ),
            },
          ]
        : []),
      {
        headerName: "Price (Each Cs)",
        mappedValue: "pricePerCase",
        width: 100,
        textAlign: "left",
        currencySymbol: currency,
        renderHeader: (value: any) => (
          <Box
            display={"flex"}
            sx={{ flexDirection: "column", alignItems: "left" }}
          >
            <Box
              display={"flex"}
              flexDirection={"column"}
              sx={{ textAlign: "left" }}
            >
              <span>{"Price"}</span>
              <span>{"(Each Cs)"}</span>
            </Box>
          </Box>
        ),
      },

      {
        headerName: "Amount",
        mappedValue: "actualAmount",
        textAlign: "left",
        currencySymbol: currency,
        width: 100,
      },
      {
        headerName: "Discount",
        mappedValue: "discount",
        currencySymbol: currency,
        width: 80,
        textAlign: "left",
      },

      {
        headerName: "Tax Amount & (%)",
        mappedValue: "taxInfo",
        width: 160,
        textAlign: "left",
        renderHeader: (value: any) => (
          <Box
            display={"flex"}
            sx={{ flexDirection: "column", alignItems: "left" }}
          >
            <Box
              display={"flex"}
              flexDirection={"column"}
              sx={{ textAlign: "left" }}
            >
              <span>{"Tax"}</span>
              <span>{`Amount ${showTaxPercentage ? "& (%)" : ""}`}</span>
            </Box>
          </Box>
        ),
        renderCell: (value: any, row: any) => {
          const isCollapsed = row.collapsed;

          const aggregateTaxAmount = value?.reduce((acc:any,curr:any)=>{
            acc += Number(curr?.taxAmount)
            return acc
          },0)
          const aggregateTaxPercent = value?.reduce((acc:any,curr:any)=>{
            acc += Number(curr?.taxPercent)
            return acc
          },0)
  
          const consolidatedTaxObj = {taxType:"All", taxAmount:aggregateTaxAmount, taxPercent:aggregateTaxPercent ,};

          return (
            <FormControl className="manage_order_filter">
            <Select
              labelId="dropdown_label"
              size="small"
              displayEmpty
              sx={{
                "& .MuiSelect-select": {
                  padding: "0px !important",
                },
                width: "100%",
                fontSize: "14px",
                padding: "0px",
                "&.Mui-focused": {
                  boxShadow: "none",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  border: "none",
                },
                
                "& .MuiSelect-icon": {
                  display: value?.length === 0 ? "none" : "block",
                  marginRight: "-11px" 
                },
              }}
              MenuProps={{
                PaperProps: {
                  sx: {
                    mt: 1,
                    padding: 0,
                    boxShadow: "none",
                    border: "1px solid #DEDEDE",
                    borderRadius: "8px",
                  },
                },
                MenuListProps: {
                  sx: {
                    padding: "7px 0",
                  },
                },
              }}
              renderValue={() => {
                return (
                  <span style={{ color: "#7c7c7c", fontSize: "13px" }}>
                    <span>
                      {`${consolidatedTaxObj?.taxType ?? ""}: ${
                        currency ?? ""
                      }\u200A${truncateToTwoDecimals(consolidatedTaxObj?.taxAmount ?? 0)}`}
                      {showTaxPercentage && `(${consolidatedTaxObj?.taxPercent ?? 0}%)`}
                    </span>
                  </span>
                );
              }}
            >
              
              {value?.length > 0 && value?.map((item: any, index: any, arr: any) => (
                <MenuItem
                  key={item?.taxType}
                  value={item?.taxType}
                  className="menuItem-test-debug"
                  sx={{
                    padding: "2px 0px",
                    borderBottom:
                      index !== arr.length - 1
                        ? "1.5px dashed #EBEBEB"
                        : "none",
                    margin: "0 10px",
                    pointerEvents: "none"
                  }}
                >
                  <div className="loadout_dropdown_menu_item">
                    <span>
                      {`${item?.taxType ?? ""}: ${currency ?? ""}${truncateToTwoDecimals(
                        item?.taxAmount ?? 0
                      )}`}
                      {showTaxPercentage && `(${truncateToTwoDecimals(item?.taxPercent) ?? 0}%)`}
                    </span>
                  </div>
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          
          );
        },
      },

      {
        headerName: "Final Amount",
        mappedValue: "finalAmount",
        currencySymbol: currency,
        width: 100,
        textAlign: "left",
        renderHeader: (value: any) => (
          <Box
            display={"flex"}
            sx={{ flexDirection: "column", alignItems: "left" }}
          >
            <Box
              display={"flex"}
              flexDirection={"column"}
              sx={{ textAlign: "left" }}
            >
              <span>{"Final"}</span>
              <span>{"Amount"}</span>
            </Box>
          </Box>
        ),
        renderCell: (value: any) => (
          <Box>
            <span
              style={{
                textAlign: "left",
                fontWeight: 600,
              }}
            >
              {`${currency}\u200A${truncateToTwoDecimals(value) ?? ""}`}
            </span>
          </Box>
        ),
      },
    ],
  };
};

export const getViewPrimaryOrderEditConfig = (
  toggleTaxInfoCollapsedStatus: (
    paramRow: viewPrimaryOrderRowsData,
    collapsed: boolean,
  ) => void,
  handleQuantityChange: (paramRow: any, changedQuantity: any, type: UOM) => void,
  handleOnBlur: (paramRow: any) => void,
  handleRemove: (paramRow: any) => void,
  handlePromotionModalVisibility: (paramRow: viewManageOrderRowsData) => void,
  disableStockCheck: boolean = false,
  isARS?: boolean
) => {
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
  const { packUnitLabelPrimary,caseUnitLabelPrimary,otherUnitLabelPrimary,currency } = ConfigDictionary;

  return {
    columns: [
      {
        headerName: "SKU Code",
        mappedValue: "batchCode",
        width: 100,
        renderHeader: (value: any) => (
          <Box display={"flex"} flexDirection={"column"}>
            <span>{"SKU"}</span>
            <span>{"Code"}</span>
          </Box>
        ),
        renderCell: (value: any, row: any) => {
          return (
              <Tooltip title={value}>
              <Box className="sku_name_truncate_text">
                <span style={TruncatedTextUptoLine(2)}>{value}</span>
              </Box>
            </Tooltip>
          );
        },
      },
      {
        headerName: "SKU Name",
        mappedValue: "skuDescription",
        width: 180,
        renderHeader: (value: any) => (
          <Box display={"flex"} flexDirection={"column"}>
            <span>{"SKU"}</span>
            <span>{"Name"}</span>
          </Box>
        ),
        renderCell: (value: any) => {
          return (
            <Tooltip title={value}>
              <Box className="sku_name_truncate_text">
                <span style={TruncatedTextUptoLine(2)}>{value}</span>
              </Box>
            </Tooltip>
          );
        },
      },
      ...(caseUnitLabelPrimary
        ? [
            {
              headerName: "Cases",
              mappedValue: "caseQuantity",
              width: 60,
              textAlign: "center",
              renderHeader: () => (
                <Box display="flex" sx={{ flexDirection: "column", alignItems: "center" }}>
                  <Box display="flex" flexDirection="column" sx={{ textAlign: "left" }}>
                    <span>{"Qty"}</span>
                    <span>{`(${caseUnitLabelPrimary})`}</span>
                  </Box>
                </Box>
              ),
              renderCell: (value: any, row: any) => {

                return (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      position: "relative",
                    }}
                  >
                    <input
                      value={value}
                      onChange={(e) => {
                        const inputValue = e.target.value;
                        if (/^\d{0,4}$/.test(inputValue) && !isNaN(+inputValue)) {
                          handleQuantityChange(row, +inputValue, UOM.CASE);
                        }
                      }}
                      onBlur={() => handleOnBlur(row)}
                      className="view_order_case_quantity_inputE"
                    />
                  </Box>
                );
              },
            },
          ]
        : []),
      ...((otherUnitLabelPrimary && !isARS)
        ? [
            {
              headerName: "Others",
              mappedValue: "otherUnitQuantity",
              width: 60,
              textAlign: "center",
              renderHeader: () => (
                <Box display="flex" sx={{ flexDirection: "column", alignItems: "center" }}>
                  <Box display="flex" flexDirection="column" sx={{ textAlign: "left" }}>
                    <span>{"Qty"}</span>
                    <span>{`(${otherUnitLabelPrimary?.slice(0, 3)})`}</span>
                  </Box>
                </Box>
              ),
              renderCell: (value: any, row: any) => {

                return (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      position: "relative",
                    }}
                  >
                    <input
                      value={value}
                      onChange={(e) => {
                        const inputValue = e.target.value;
                        if (/^\d{0,4}$/.test(inputValue) && !isNaN(+inputValue)) {
                          handleQuantityChange(row, +inputValue, UOM.OTHER);
                        }
                      }}
                      onBlur={() => handleOnBlur(row)}
                      className="view_order_case_quantity_input"
                    />
                  </Box>
                );
              },
            },
          ]
        : []),
      ...((packUnitLabelPrimary && !isARS)
        ? [
            {
              headerName: "Pieces",
              mappedValue: "pieceQuantity",
              width: 60,
              textAlign: "center",
              renderHeader: () => (
                <Box display="flex" sx={{ flexDirection: "column", alignItems: "center" }}>
                  <Box display="flex" flexDirection="column" sx={{ textAlign: "left" }}>
                    <span>{"Qty"}</span>
                    <span>{`(${packUnitLabelPrimary})`}</span>
                  </Box>
                </Box>
              ),
              renderCell: (value: any, row: any) => {

                return (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      position: "relative",
                    }}
                  >
                    <input
                      value={value}
                      onChange={(e) => {
                        const inputValue = e.target.value;
                        if (/^\d{0,4}$/.test(inputValue) && !isNaN(+inputValue)) {
                          handleQuantityChange(row, +inputValue, UOM.PIECE);
                        }
                      }}
                      onBlur={() => handleOnBlur(row)}
                      className="view_order_pack_quantity_inputE"
                    />
                  </Box>
                );
              },
            },
          ]
        : []),
      {
        headerName: "Price (Each Cs)",
        mappedValue: "pricePerCase",
        width: 100,
        textAlign: "left",
        currencySymbol: currency,
        renderHeader: (value: any) => (
          <Box
            display={"flex"}
            sx={{ flexDirection: "column", alignItems: "left" }}
          >
            <Box
              display={"flex"}
              flexDirection={"column"}
              sx={{ textAlign: "left" }}
            >
              <span>{"Price"}</span>
              <span>{"(Each Cs)"}</span>
            </Box>
          </Box>
        ),
      },

      {
        headerName: "Amount",
        mappedValue: "actualAmount",
        textAlign: "left",
        currencySymbol: currency,
        width: 100,
      },
      {
        headerName: "",
        mappedValue: "",
        width: 35,
        renderCell: (value: any, row: any) => {
          return row?.source?.toLowerCase() === "ars" ? (<></>) : (
            <button
              className="view_order_manage_order_table_button"
              onClick={() => {
                handleRemove(row);
              }}
            >
              <SubtractIcon style={{ width: "16px", height: "16px" }} />
            </button>
          );
        },
      },
    ],
  };
};

  const getQuantityLabel = () => {
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
  const { packUnitLabelPrimary,caseUnitLabelPrimary,otherUnitLabelPrimary } = ConfigDictionary;

    const labels: string[] = [
      caseUnitLabelPrimary ? `${caseUnitLabelPrimary}` : "",
      otherUnitLabelPrimary ? `${otherUnitLabelPrimary}` : "",
      packUnitLabelPrimary ? `${packUnitLabelPrimary}` : ""
    ].filter(Boolean); // Removes empty strings
  
    return labels.length > 0 ? `Qty (${labels.join(", ")})` : "Qty";
  };

export const getMetaData1 = (currencySymbol: string): any[] => [
  {
    keys: "totalCasePieceOtherQuantity",
    label: getQuantityLabel(),
    index: 1,
    valueType: "String",
  },
  {
    keys: "totalQuantity",
    label: "Total Products",
    index: 2,
    valueType: "Number",
  },
  {
    keys: "netAmount",
    label: "Total Amount",
    index: 3,
    valueType: "Number",
    currencySymbol: currencySymbol,
  },
  {
    keys: "discountValue",
    label: "Discount Value",
    index: 4,
    valueType: "Number",
    currencySymbol: currencySymbol,
  },
  {
    keys: "taxAmount",
    label: "Tax Amount",
    index: 5,
    valueType: "Number",
    currencySymbol: currencySymbol,
  },
  {
    keys: "billAmount",
    label: "Final Amount",
    index: 6,
    valueType: "Number",
    currencySymbol: currencySymbol,
    focusField: true,
  },
];

export const metaData2 = (getKgbplDeliveryData?: boolean): any[] => {
  let metadata = [
    {
      keys: "supplierCode",
      label: "Supplier Code",
      index: 1,
      removeEllipsis: false,
      truncateTextAfterChar: 43,
    },
    {
      keys: "supplierName",
      label: "Supplier Name",
      index: 2,
      removeEllipsis: false,
      truncateTextAfterChar: 43,
    },
    {
      keys: "deliveryDate",
      label: "Est. Delivery Date",
      index: 3,
      removeEllipsis: true,
    },
  ];
  let kgbplMetadata = [
    {
      keys: "siteId",
      label: "Site ID",
      index: 4,
      removeEllipsis: true,
      truncateTextAfterChar: 43,
    },
    {
      keys: "warehouseId",
      label: "Warehouse ID",
      index: 5,
      removeEllipsis: true,
      truncateTextAfterChar: 43,
    },
    {
      keys: "totalWeight",
      label: "Total Order Weight (tons)",
      index: 6,
      valueType: "Number",
      removeEllipsis: true,
    },
  ]
  let grnDeliveryData = [
    {
      keys: "vehicleNumber",
      label: "Vehicle No.",
      index: 4,
      valueType: "String",
      removeEllipsis: true,
    },
    {
      keys: "dispatchDate",
      label: "Dispatch Date",
      index: 5,
      valueType: "String",
      removeEllipsis: true,
    },
    {
      keys: "grnActionTime",
      label: "GRN Date and Time",
      index: 6,
      valueType: "String",
      removeEllipsis: true,
    },
  ];
  if(getKgbplDeliveryData) {
    metadata = [...metadata, ...kgbplMetadata];
  } else {
    metadata = [...metadata, ...grnDeliveryData];
  }
  return metadata;
}

export const getMetaData1ViewPrimaryOMS = (currencySymbol: string,getKgbplDeliveryData?: boolean): any[] => {

  let metadata = [ {
    keys: "totalCasePieceOtherQuantity",
    label: getQuantityLabel(),
    index: 1,
    valueType: "String",
  },
  {
    keys: "totalQuantity",
    label: "Total Products",
    index: 2,
    valueType: "Number",
  },
  {
    keys: "netAmount",
    label: "Total Amount",
    index: 3,
    valueType: "Number",
    currencySymbol: currencySymbol,
  },
  {
    keys: "discountValue",
    label: "Discount Value",
    index: 4,
    valueType: "Number",
    currencySymbol: currencySymbol,
  },
  {
    keys: "taxAmount",
    label: "Tax Amount",
    index: 5,
    valueType: "Number",
    currencySymbol: currencySymbol,
  },
  {
    keys: "billAmount",
    label: "Final Amount",
    index: 6,
    valueType: "Number",
    currencySymbol: currencySymbol,
  }]

  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
  const { caseUnitLabelPrimary,otherUnitLabelPrimary } = ConfigDictionary;

  let kgbplMetadata = [
    {
      keys: "totalQuantity",
      label: "Total Products",
      index: 1,
      valueType: "Number",
    },

    {
      keys: "totalCasePieceOtherQuantity",
      label: getQuantityLabel(),
      index: 2,
      valueType: "String",
    },


    {
      keys: "totalConvertedCasesPrimaryOMS",
      label: `Total Order Qty (${caseUnitLabelPrimary})`,
      index: 3,
      valueType: "Number",
    },  
    
    {
      keys: "totalWeight",
      label: "Total Order Weight (tons)",
      index: 4,
      valueType: "Number",
      removeEllipsis: true,
    },
   
    {
      keys: "netAmount",
      label: "Total Amount",
      index: 5,
      valueType: "Number",
      currencySymbol: currencySymbol,
    },
    {
      keys: "discountValue",
      label: "Discount Value",
      index: 6,
      valueType: "Number",
      currencySymbol: currencySymbol,
    },
    {
      keys: "taxAmount",
      label: "Tax Amount",
      index: 7,
      valueType: "Number",
      currencySymbol: currencySymbol,
    },
    {
      keys: "billAmount",
      label: "Final Amount",
      index: 8,
      valueType: "Number",
      currencySymbol: currencySymbol,
    },
    
  
  ]


  if(getKgbplDeliveryData) {
    return kgbplMetadata;
  } 

  return metadata
};

export const getMetaData1ViewPrimaryOMSV2 = () => {

  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
  const { currency } = ConfigDictionary;

  const totalLoadWeight = [{
      keys: "totalLoadWeightTonsViewPrimaryOMS",
      label: `Total load weight`,
      index: 3,
      valueType: "Number",
      render: "Jsx",
    }]

  const metaData = [
    {
      keys: "lineCount",
      label: "Total products",
      index: 1,
      valueType: "Number",
    },
    {
      keys: "totalConvertedCasesViewPrimaryOMS",
      label: "Qty ordered",
      index: 2,
      valueType: "Number",
      render: "Jsx",
    },
    ... totalLoadWeight,
    {
      keys: "totalAmount",
      label: "Amount (exc. discount & tax)",
      index: 4,
      valueType: "Number",
      currencySymbol: currency,

    },
    {
      keys: "totalDiscountValue",
      label: "Discount value",
      index: 5,
      valueType: "Number",
      currencySymbol: currency,
      customStyles: {
        color: "#1863C5"
      },
      render: "Jsx",
    },
 
    {
      keys: "taxAmount",
      label: "Tax Applicable",
      index: 6,
      valueType: "Number",
      currencySymbol: currency,
      customStyles: {
        color: "#B96D16"
      }
    },
    {
      keys: "netAmount",
      label: "Final value",
      index: 7,
      valueType: "Number",
      currencySymbol: currency,
      focusField: true,
      customStyles: {
        color: "#1B7713"
      }
    },
  ];

  return metaData;
}

function getDistinctSites(mapping: Record<string, string[]>): string[] {
  return Object.keys(mapping);
}
export const metaData2ViewPrimaryOMS = (getKgbplDeliveryData?: boolean,siteId: string = "", siteWarehouseMappingValue?:any,status?:string): any[] => {
  const ConfigDictionary = JSON.parse(localStorage.getItem("ConfigDictionary") ?? "{}");
  const {showSiteWarehouseFilterViewPrimaryOMS} = ConfigDictionary
  const warehouseOptions = siteWarehouseMappingValue[siteId] || [];
  
  const mapping = siteWarehouseMappingValue ?? {};

  if (siteId && !mapping.hasOwnProperty(siteId)) {
    mapping[siteId] = [];
  }
  
  let metadata = [
    {
      keys: "supplierCode",
      label: "Supplier Code",
      index: 1,
      removeEllipsis: false,
      truncateTextAfterChar: 43,
    },
    {
      keys: "supplierName",
      label: "Supplier Name",
      index: 2,
      removeEllipsis: false,
      truncateTextAfterChar: 43,
    },
    {
      keys: "deliveryDate",
      label: "Est. Delivery Date",
      index: 3,
      removeEllipsis: true,
    },
  ];
  let kgbplMetadata = [
    {
      keys: "outletName",
      label: "Distributor Name",
      index: 1,
      removeEllipsis: false,
      truncateTextAfterChar: 43,
    },
    
    {
      keys: "supplierName",
      label: "Company Name",
      index: 2,
      removeEllipsis: false,
      truncateTextAfterChar: 43,
    },

    {
      keys: "outletCity",
      label: "Distributor City",
      index: 3,
      removeEllipsis: false,
      truncateTextAfterChar: 43,
    },
    {
      keys: "siteId",
      label: "Site ID",
      index: 4,
      removeEllipsis: true,
      truncateTextAfterChar: 43,
      dropdownOptions: ( status?.toLowerCase() == "pending" && showSiteWarehouseFilterViewPrimaryOMS ) ? getDistinctSites(siteWarehouseMappingValue)  : undefined,
    },
   
    {
      keys: "outletCode",
      label: "Distributor Code",
      index: 5,
      removeEllipsis: false,
      truncateTextAfterChar: 43,
    },
  

    {
      keys: "supplierCode",
      label: "Company Code",
      index: 6,
      removeEllipsis: false,
      truncateTextAfterChar: 43,
    },
    
    {
      keys: "deliveryDate",
      label: "Est. Delivery Date",
      index: 7,
      removeEllipsis: true,
    },

    {
      keys: "warehouseId",
      label: "Warehouse ID",
      index: 8,
      removeEllipsis: true,
      truncateTextAfterChar: 43,
      dropdownOptions: ( status?.toLowerCase() == "pending"  && showSiteWarehouseFilterViewPrimaryOMS ) ? warehouseOptions : undefined
    },
    
  ]
  if(getKgbplDeliveryData) {
    return kgbplMetadata;
  } 
  return metadata;
}

